export const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000',
  identityApiUrl: import.meta.env.VITE_IDENTITY_API_URL || 'http://localhost:5001',
  storageApiUrl: import.meta.env.VITE_STORAGE_API_URL || 'http://localhost:5002',
  appName: import.meta.env.VITE_APP_NAME || 'Tanazom Dashboard',
  appVersion: import.meta.env.VITE_APP_VERSION || '1.0.0',
  enableNotifications: import.meta.env.VITE_ENABLE_NOTIFICATIONS === 'true',
  enableChat: import.meta.env.VITE_ENABLE_CHAT === 'true',
  googleMapsKey: import.meta.env.VITE_GOOGLE_MAPS_KEY || '',
  tenantIdentifier: import.meta.env.VITE_TENANT_IDENTIFIER || 'maksab',
  appEnv: import.meta.env.VITE_APP_ENV || 'development',
} as const;

/// FCM topic suffix per environment — mirrors the mobile apps'
/// `/topics/{audience}[.staging|.dev]` subscription convention.
export const FCM_TOPIC_SUFFIX =
  config.appEnv === 'staging' ? '.staging'
  : config.appEnv === 'production' ? ''
  : '.dev';

export const API_VERSION = 'v1';
export const IDENTITY_API_VERSION = 'v1';

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'maksab_access_token',
  REFRESH_TOKEN: 'maksab_refresh_token',
  USER: 'maksab_user',
  THEME: 'maksab_theme',
  LANGUAGE: 'maksab_language',
} as const;

export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_PAGE_SIZE: 20,
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
} as const;

export const DATE_FORMATS = {
  API: 'dd-MM-yyyy',
  DISPLAY: 'dd/MM/yyyy',
  DISPLAY_WITH_TIME: 'dd/MM/yyyy HH:mm',
  ISO: "yyyy-MM-dd'T'HH:mm:ss",
} as const;
